import { apiURL } from "../../config";

export async function getDecisionUnitList(axiosPrivate) {
	return axiosPrivate
		.get(`${apiURL}/user/organization-units.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				const resultData = res.data;
				const parsedData = [];

				for (const result of resultData) {
					if (result.roles.includes("member")) parsedData.push(result.organizationUnit);
				}

				return parsedData;
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getUnitList(axiosPrivate) {
	return axiosPrivate
		.get(`${apiURL}/user/organization-units.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				const resultData = res.data;
				const parsedData = {};

				for (const result of resultData) {
					parsedData[result.organizationUnit.id] = result.roles;
				}

				return parsedData;
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getUserUnitsList(axiosPrivate) {
	return axiosPrivate
		.get(`${apiURL}/user/organization-units.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				const resultData = res.data;
				const parsedData = [];

				for (const result of resultData) {
					parsedData.push(result.organizationUnit);
				}

				return parsedData;
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function createOrganizationUnit(axiosPrivate, unitName, adminId) {
	return axiosPrivate
		.post(`${apiURL}/organization-unit.json`, {
			name: unitName,
			parent: null,
			admin: adminId
		})
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				return res.data;
			}
		})
		.catch((err) => {
			return err.response;
		});
}
